import { Address } from '@shared/components/address/models/address.model';

// ENTITIES ##########################################################
// MODEL USED FOR TRANSITION APP<->API (TransitionalModelObject)
export class AccountInitializationTMO {

	public email: string = undefined;

	public firstname: string = undefined;

	public lastname: string = undefined;

	public name: string = undefined;

	public detailedDescription: string = undefined;

	public taxNumber?: string = undefined;

	public vatId?: string = undefined;

	public billingAddress?: Address = new Address();

	public phoneNumber?: string = undefined;

	public tenantType?: AccountTenantTypeEnum = undefined;

	public vendorCode?: string = undefined;

	public additionalData?: string = undefined;

	public userRoles?: AccountUserRoleEnum[] = undefined;
}


// MODEL USED IN APPLICATION (with additional properties)
export class AccountInitialization extends AccountInitializationTMO {
	public id?: string = undefined;

	public etag?: string = undefined;
}


// INTERFACES ########################################################
// API interfaces ****************************************************
// UI interfaces *****************************************************


// ENUMS #############################################################
// API enums *********************************************************
export enum AccountTenantTypeEnum {
	DISTRIBUTOR = 'distributor',
	MANAGED = 'managed',
	PARTNER = 'partner',
	STANDARD = 'standard',
	TEST = 'test'
}

export enum AccountUserRoleEnum {
	ADMIN_DISTRIBUTOR = 'admin_distributor',
	ADMIN_PARTNER = 'admin_partner',
	ADMIN_TENANT = 'admin_tenant',
	ADMIN_VENDOR = 'admin_vendor'
}

// UI enums *********************************************************
